import { render, staticRenderFns } from "./dispensed_report.vue?vue&type=template&id=0f77bd1a&scoped=true&"
import script from "./dispensed_report.vue?vue&type=script&lang=js&"
export * from "./dispensed_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77bd1a",
  null
  
)

export default component.exports